import React from 'react';
import styles from './VCUpdatesPage.module.css';

export interface MetricCardProps {
  label: string;
  value: string;
  trend?: 'up' | 'down' | 'neutral';
  delta?: string;
  category: string;
  icon?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  trend,
  delta,
  category,
  icon,
}) => {
  const getTrendIcon = () => {
    if (trend === 'up') return '↗️';
    if (trend === 'down') return '↘️';
    if (trend === 'neutral') return '→';
    return null;
  };

  const trendIcon = getTrendIcon();

  return (
    <div className={`${styles.metricCard} ${styles[`metric${category.charAt(0).toUpperCase()}${category.slice(1)}`] || ''}`}>
      <div className={styles.metricHeader}>
        {icon && <span className={styles.metricIcon}>{icon}</span>}
        <div className={styles.metricLabel}>{label}</div>
      </div>
      
      <div className={styles.metricValueRow}>
        <div className={styles.metricValue}>{value}</div>
        {(trendIcon || delta) && (
          <div className={styles.metricTrendContainer}>
            {trendIcon && <span className={styles.metricTrend}>{trendIcon}</span>}
            {delta && <span className={styles.metricDelta}>{delta}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;

